import { Search } from "lucide-react"
import { forwardRef } from "react"
import { useInMobileView } from "../../hooks"

interface Props {
  query: string
  setQuery: (value: string) => void
  onFocus: () => void
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
  controlsId: string
  isOpen: boolean
}

const isMac = () => {
  return (
    typeof navigator !== "undefined" &&
    navigator.platform.toUpperCase().indexOf("MAC") >= 0
  )
}

const PageSearchForm = forwardRef<HTMLInputElement, Props>(
  ({ query, setQuery, onFocus, onKeyDown, controlsId, isOpen }, ref) => {
    const shortcutKey = isMac() ? "⌘" : "Ctrl"
    const inMobileView = useInMobileView()

    const placeholder = inMobileView
      ? "Search"
      : "Search for anything (LO's, Leads, Subscriptions..)"

    return (
      <div className="relative w-full group sm:max-w-[calc(42rem*0.75)]">
        <div className="absolute inset-y-0 left-2.5 md:left-4 flex items-center pointer-events-none">
          <Search
            className="text-slate-500 group-focus-within:text-primary-400 transition-colors"
            size={inMobileView ? 16 : 20}
            aria-hidden="true"
          />
        </div>
        <form autoComplete="off" onSubmit={e => e.preventDefault()}>
          <label htmlFor="search-field" className="sr-only">
            Search
          </label>
          <input
            ref={ref}
            id="search-field"
            className="bg-zinc-100 block w-full h-full pl-8 md:pl-12 pr-2 md:pr-16 py-2.5 text-sm border-transparent rounded-xl text-base-dark placeholder-slate-500 focus:ring-2 focus:ring-primary-400/20 focus:bg-slate-100 focus:placeholder-slate-400 focus:outline-none focus:border-primary-400"
            placeholder={placeholder}
            type="search"
            name="search"
            autoComplete="off"
            role="combobox"
            aria-controls={controlsId}
            aria-expanded={isOpen}
            aria-autocomplete="list"
            value={query}
            onChange={e => setQuery(e.target.value)}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
          />
        </form>
        <div className="absolute inset-y-0 right-0 pr-4 flex items-center pointer-events-none">
          <div className="hidden sm:inline-flex items-center px-2 py-0.5 text-xs font-semibold text-slate-500 bg-white border border-slate-200 rounded-md shadow-sm">
            <span>{shortcutKey}</span>
            <span className="ml-1.5">K</span>
          </div>
        </div>
      </div>
    )
  }
)

PageSearchForm.displayName = "PageSearchForm"

export default PageSearchForm
